import { render } from "./Incall.vue?vue&type=template&id=115d23e3&scoped=true"
import script from "./Incall.vue?vue&type=script&lang=js"
export * from "./Incall.vue?vue&type=script&lang=js"

import "./Incall.vue?vue&type=style&index=0&id=115d23e3&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115d23e3"]])

export default __exports__